import styled from 'styled-components';

export const Wrapper = styled.div`
  min-height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.grey1100};
  color: ${({ theme }) => theme.palette.white};

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    min-height: 80px;
  }
`;

export const Rectangle = styled.div`
  width: 1px;
  height: 24px;
  background: ${({ theme }) => theme.palette.whiteAlpha300};
  margin: 0 16px 0px 16px;
  color: ${({ theme }) => theme.palette.white};
`;
